import React,{useEffect,useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Bell,Trash2} from 'lucide-react';
import {toast} from 'sonner';
import {api,errorToast} from '../lib/api';
export const AiAlerts=()=>{
 const{t}=useTranslation();const[items,setItems]=useState<any[]>([]);
 const load=()=>api.get('/ai/alerts').then(r=>setItems(r.data)).catch(()=>{});
 useEffect(()=>{load();},[]);
 const remove=async(id:string)=>{try{await api.delete(`/ai/alerts/${id}`);setItems(items.filter(a=>a.id!==id));toast.success(t('Alerte supprimée'));}catch(e){errorToast(e);}};
 if(!items.length)return null;
 return <section className="ai-alerts" data-testid="ai-alerts"><h3><Bell size={15}/>{t('Mes alertes Assistant')}</h3><ul>{items.map(a=><li key={a.id} data-testid={`ai-alert-${a.id}`}><div><strong>{a.query}</strong><small className="muted">{a.matches?`${a.matches} ${t('annonce(s) trouvée(s)')}`:t('En veille')}</small></div><button type="button" className="text-link danger" data-testid={`ai-alert-delete-${a.id}`} onClick={()=>remove(a.id)}><Trash2 size={13}/>{t('Supprimer')}</button></li>)}</ul></section>;
};
